if (!customElements.get('custom-modal')) {
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.activeIds = [];
      this.handleKeydown = this.handleKeydown.bind(this); // Bind the method to the class instance
      this.observer = new MutationObserver(() => this.handleContentUpdate());
      this.searchParams = new URLSearchParams(window.location.search);
    }

    handleContentUpdate() {
      const modalId = this.activeIds[this.activeIds.length - 1];
      const elToTrap = this.querySelector(`[data-modal-content="${modalId}"]:not([data-update-focus="false"]):not(template)`); //exclude modals from this with data-update-focus="false"
      if (elToTrap) {
        trapFocus(elToTrap);
      }
    }
    
    animateIn() {
      const modalId = this.activeIds[this.activeIds.length - 1];
      const elToAnimate = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`); 
      if (!elToAnimate) return;    
      trapFocus(elToAnimate);
      elToAnimate.classList.remove('modal-invisible');
      elToAnimate.classList.add('modal-visible'); 
    }
    
    animateOut(modalId) {
      const elToAnimate = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`); 
      if (!elToAnimate) return;
      elToAnimate.classList.add('modal-invisible');
      elToAnimate.classList.remove('modal-visible'); 
      elToAnimate.addEventListener('transitionend', () => {
        const template = document.querySelector(`[data-modal-content="${modalId}"]`); 
        if (template) template.innerHTML = elToAnimate.innerHTML;
        elToAnimate.remove();
        document.querySelector(`[data-modal-action="open"][data-modal-id="${modalId}"]:not([data-hover-trigger])`)?.focus();
        this.classList.remove('hovered');
      });
    }
    
    open(modalId, closeOnExit, parent) {  
      if (!modalId) return;  
      if (!this.activeIds.some(x => x === modalId)) {
        this.activeIds.push(modalId);
        const template = document.querySelector(`[data-modal-content="${modalId}"]`); 
        if (!template) return;    
        const newModalElement = document.createElement('div');
        newModalElement.innerHTML = template.cloneNode(true).innerHTML;
        newModalElement.classList.add('modal-invisible');
        newModalElement.setAttribute('role', 'dialog');
        newModalElement.setAttribute('aria-modal', true);
        [...template.attributes].forEach(attr => newModalElement.setAttribute(attr.nodeName, attr.nodeValue));
        if (parent) {
          parent.appendChild(newModalElement);
        } else this.appendChild(newModalElement);
        
        this.querySelectorAll('.modal-visible:not(:last-of-type) > div').forEach(el => el.classList.add('layered-view'))
        setTimeout(() => {
          this.animateIn();  
        }, 1);
        
        window.addEventListener('keydown', this.handleKeydown); // Attach keydown listener
        if (closeOnExit) {
          if (parent) {
            parent.addEventListener('mouseleave', () => {
              this.close(modalId);
            }, { once: true });
            return; 
          }
          newModalElement.addEventListener('mouseenter', () => {
            newModalElement.addEventListener('mouseleave', () => {
              this.close(modalId);
            }, { once: true });
          }, { once: true });
        }
      }
    }
    
    close(modalId = this.activeIds[this.activeIds.length - 1]) { 
      if (this.activeIds.find(x => x === modalId)) {
        this.animateOut(modalId);
        this.activeIds = this.activeIds.filter(x => x !== modalId);
        this.querySelector('.modal-visible > div')?.classList.remove('layered-view');
      }
    }

    closeAll() {
      while (this.activeIds.length) {
        this.close(this.activeIds[this.activeIds.length - 1]);
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
    
    connectedCallback() {  
      this.observer.observe(this, { childList: true, subtree: true });
      
      if (this.searchParams.get('reset')) {
        if (!window.location.pathname.includes('account')) {
          const prefix = innerWidth > 1024 ? 'account-login-sections' : 'mobile-account-login-sections';
          const link = [...document.querySelectorAll('a[href="/account"][data-modal-id]')]
            .find(a => a.dataset.modalId.startsWith(prefix));

          if (link) {
            this.open(link.dataset.modalId);
            setTimeout(() => {
              document.querySelector('[data-account-target="forgot-password"]')?.click();
            }, 0);
          }
        }
      }

      window.addEventListener('modal:openById', (e) => {
        this.open(e.detail);
      });

      //this.open('desktop-menu-full_dropdown_6nwaaW') //Shop Menu Testing
      //this.open('desktop-menu-simple_dropdown_QiA7dc') //Brand Menu Testing
      
      window.addEventListener('modal:closeById', (e) => {
        this.close(e.detail);
      });
      
      window.addEventListener('mouseover', (e) => {
        const hoveredElement = e.target.closest('[data-modal-action][data-hover-trigger]');
        if (!hoveredElement) return;
        
        const {
          modalAction,
          modalId
        } = hoveredElement.dataset;
                        
        switch (modalAction) {
          case 'open':   
            if (this.activeIds.find(x => x === modalId)) return;
            this.classList.add('hovered');
            this.activeIds = [];
            document.querySelectorAll('[data-hover-trigger] [data-modal-content]').forEach(el => el.remove());
            this.open(modalId, true, hoveredElement);
            break;
          default: break;
        }
      });
      
      window.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() === 'custom-modal') {
          this.close();
        }
        
        const clickedElement = e.target.closest('[data-modal-action]');
        if (!clickedElement) return;
        
        if (clickedElement.closest('[data-hover-trigger]') && document.activeElement !== clickedElement) return;
        
        const {
          modalAction,
          modalId
        } = clickedElement.dataset;
                        
        switch (modalAction) {
          case 'open':   
            e.preventDefault();
            this.open(modalId);
            break;
          case 'close':
            this.close();
            break;
          case 'closeAll':
            this.closeAll();
            break;
          default: break;
        }
      });
    }
  }
  
  customElements.define('custom-modal', Modal);
}
